<template>
	<div>
		<div class="cont">
			<!-- <Breadcrumb :pathList='pathList'></Breadcrumb> -->
			<div class="infoItem">
				<div class="flex flex-b">
					<div class="flex">
						<img @click="$router.go(-1)" class="pointer" src="../../assets/icon/back.png" alt=""
							style="width: 20px;height: 20px;" />
						<div class="tit">{{title}}</div>
					</div>
				</div>
				<div class="det" v-html="detail.value"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getConfigDetail
	} from '@/api/common';
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import toTop from '../../components/toTop.vue'
	import Footer from '../../components/Footer.vue'
	export default {
		data() {
			return {
				detail: '',
				title: ''
			}
		},
		mounted() {
			this.getConfigDetail()
		},
		methods: {
			async getConfigDetail() {
				let key = ''
				if (this.$route.query.source == 1) {
					key = 'USER_SERVICE_AGREEMENT'
					this.title = '用户协议'
				}
				if (this.$route.query.source == 2) {
					key = 'PRIVACY_POLICY'
					this.title = '隐私政策'
				}
				if (this.$route.query.source == 3) {
					key = 'SIDE_AGREEMENT'
					this.title = '补充协议'
				}
				const {
					status,
					data
				} = await getConfigDetail({
					key: key
				})
				this.detail = data.result
			},
		},
		components: {
			Breadcrumb,
			toTop,
			Footer
		}
	}
</script>

<style lang="less" scoped>
	.cont {
		padding: 30px 133px 0;
		min-height: 100vh;

		.infoItem {
			padding: 20px 0;
			margin: 20px 0;

			.tit {
				margin-left: 10px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
			}

			.time {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;
			}

			.det {
				margin-top: 16px;
				padding-top: 16px;
				border-top: 1px solid #EEEEEE;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 18px;
				color: #000000;
			}

			.t {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}
	}

	.login-btn {
		margin-top: 280px;
		width: 364px;
		height: 59px;
		background: url('../../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}
</style>